import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { isNil } from 'lodash-es';
import { palette, Typography } from '@dev/ee-components';
import styled from 'styled-components';
import { Link } from '@material-ui/core';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';
import { links } from '@/services/dictionaries/links';
import { useSecurity } from '@/services/hooks/useSecurity';
import { UTMSection } from './UTM';
import { TrackLinksGAToggle } from './TrackLinksGAToggle';

const DescriptionWrapper = styled.div`
    margin-left: 60px;
`;

export const TrackLinksGA = (): JSX.Element => {
    const { t } = useTranslation();
    const { isReseller } = useSecurity();
    const { campaign } = useSelector(getCampainCreatorStore);
    const isChecked = !isNil(campaign?.CampaignTemplates?.[0]?.UTM?.UtmSource);

    return (
        <>
            <TrackLinksGAToggle isChecked={isChecked} />
            {isChecked && (
                <>
                    <DescriptionWrapper>
                        <Typography variant="body1">
                            {t('tracklinkGA_desc')}{' '}
                            {!isReseller && (
                                <Link
                                    target="_blank"
                                    style={{ color: palette.indigo[6] }}
                                    href={links.manageUTMparameters}
                                >
                                    {t('learnmore')}
                                </Link>
                            )}
                        </Typography>
                    </DescriptionWrapper>
                    <UTMSection />
                </>
            )}
        </>
    );
};
